import React from "react";
import { HStack } from "@chakra-ui/react";

import { useAuthenticationMode } from "modules/authentication/infrastructure/useAuthenticationMode";
import { AuthenticationMode } from "modules/authentication/application/types/AuthenticationMode";
import { SsoLoginButton } from "modules/authentication/presentation/LoginForm/SsoLoginButton";

import { Login } from "../Authentication/Login";
import { Register } from "../Authentication/Register";

const DesktopAuthentication = () => {
  const authenticationMode = useAuthenticationMode();

  switch (authenticationMode) {
    case AuthenticationMode.Guest:
      return <></>;
    case AuthenticationMode.Sso:
    case AuthenticationMode.GuestAndSso:
      return <SsoLoginButton />;
    case AuthenticationMode.Local:
    case AuthenticationMode.LocalAndSso:
    case AuthenticationMode.LocalAndGuest:
    case AuthenticationMode.LocalAndGuestAndSso:
      return <LoginRegister />;
    default:
      return <></>;
  }
};

const LoginRegister = () => {
  return (
    <HStack
      ml={8}
      d="flex"
      alignItems="center"
      justifyContent="center"
      spacing={4}
    >
      <Login />
      <Register />
    </HStack>
  );
};

export { DesktopAuthentication };
